module.exports = __webpack_public_path__ + "static/media/darkGroup.89565651.svg";